import Grid from '@material-ui/core/Grid';
import React from 'react';

import activationCodeControl from '../../controls/ActivationCodeControl';
import dateOfBirthControl from '../../controls/DateOfBirthControl';
import last4SsnControl from '../../controls/Last4SsnControl';

export type ActivationCodeFormProps = {
    control: any;
    errors: any;
};

function ActivationCodeForm({ control, errors }: ActivationCodeFormProps): JSX.Element {
    return (
        <Grid container spacing={9}>
            <Grid container justifyContent='center' item xs={12}>
                <Grid item xs={11} sm={8}></Grid>
                <Grid item xs={11} sm={8}>
                    {activationCodeControl(control, errors)}
                </Grid>
                <Grid item xs={11} sm={8}></Grid>
                <Grid item xs={11} sm={8}>
                    {dateOfBirthControl(control, errors, undefined)}
                </Grid>
                <Grid item xs={11} sm={8}></Grid>
                <Grid item xs={11} sm={8}>
                    {last4SsnControl(control, errors, true, undefined)}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ActivationCodeForm;
